var accordionTitleStyles = {
    root: function (_a) {
        var props = _a.props, theme = _a.theme;
        var active = props.active;
        var _b = theme.siteVariables, arrowDown = _b.arrowDown, arrowRight = _b.arrowRight;
        return {
            display: 'inline-block',
            verticalAlign: 'middle',
            padding: '.5rem 0',
            cursor: 'pointer',
            '::before': {
                userSelect: 'none',
                content: active ? "\"" + arrowDown + "\"" : "\"" + arrowRight + "\"",
            },
        };
    },
};
export default accordionTitleStyles;
